// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-layout{--tw-text-opacity:1;color:rgb(34 41 47 / var(--tw-text-opacity));-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.default-layout>main{margin-left:auto;margin-right:auto;margin-top:4rem;outline:2px solid transparent;outline-offset:2px}@media (min-width: 1024px){.default-layout>main>*{margin-left:auto;margin-right:auto;max-width:1024px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
